/**
 * Manual trigger for the newsletter popup.
 *
 * Shopify's "url" settings reject bare fragments such as #newsletter-popup, so
 * several link formats are accepted:
 *
 *   /?newsletter-popup                        recommended, falls back to the
 *                                             home page without JavaScript
 *   /newsletter-popup                         path form
 *   /#newsletter-popup                        hash form
 *   [data-newsletter-popup]                   any element, no link needed
 *
 * Do not wrap the newsletter-popup custom element. A subclass created inside
 * this file can fail to upgrade, which disables both the appearance delay and
 * the Drawer listeners the button needs.
 */
(function () {
    'use strict';

    var KEY = 'newsletter-popup';
    var POPUP_SELECTOR = 'newsletter-popup, [drawer-type="newsletter-popup"]';
    var PATH_PATTERN = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?newsletter-popup$/i;

    function parseUrl(value) {
        try {
            return new URL(value, window.location.href);
        } catch (error) {
            return null;
        }
    }

    function pointsToPopup(url) {
        if (!url) return false;
        return (
            url.hash === '#' + KEY ||
            url.searchParams.has(KEY) ||
            PATH_PATTERN.test(url.pathname.replace(/\/+$/, ''))
        );
    }

    function hrefPointsToPopup(href) {
        if (!href) return false;
        if (pointsToPopup(parseUrl(href))) return true;
        return /newsletter-popup/i.test(href);
    }

    function dispatchDrawer(type, drawerType) {
        document.dispatchEvent(
            new CustomEvent(type, {
                bubbles: true,
                detail: { drawerType: drawerType },
            })
        );
    }

    function openPopup() {
        var popup = document.querySelector(POPUP_SELECTOR);
        if (!popup) return false;

        // The theme's show() no-ops after the first appearance (drawerShown).
        // Dispatch the same Drawer event so a button can reopen it.
        dispatchDrawer('action:showDrawer', KEY);
        popup.drawerShown = true;
        return true;
    }

    function openFromUrl() {
        var url = parseUrl(window.location.href);
        if (!pointsToPopup(url)) return;
        if (!openPopup()) return;

        url.hash = '';
        url.searchParams.delete(KEY);
        window.history.replaceState(null, '', url.pathname + url.search);
    }

    function isTrigger(element) {
        if (!(element instanceof Element)) return false;
        if (element.hasAttribute('data-newsletter-popup')) return true;
        if (element.getAttribute('drawer-to-open') === KEY) return true;
        if (element.tagName === 'A' && hrefPointsToPopup(element.getAttribute('href'))) {
            return true;
        }
        return false;
    }

    document.addEventListener(
        'click',
        function (event) {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) {
                return;
            }

            var target = event.target;
            if (!(target instanceof Element)) return;

            var trigger = target.closest(
                'a[href], [data-newsletter-popup], [drawer-to-open="' + KEY + '"]'
            );
            if (!trigger || !isTrigger(trigger)) return;

            if (openPopup()) event.preventDefault();
        },
        true
    );

    window.addEventListener('hashchange', openFromUrl);

    function scheduleAppearance(popup) {
        if (!popup || popup.hasAttribute('manual-only') || popup.drawerShown) return;

        try {
            if (localStorage.getItem('theme:popup-filled') === 'true') return;
            if (
                popup.hasAttribute('only-once') &&
                localStorage.getItem('theme:popup-appeared') === 'true'
            ) {
                return;
            }
        } catch (error) {
            /* storage unavailable */
        }

        var delay = (parseInt(popup.getAttribute('apparition-delay'), 10) || 0) * 1000;

        var show = function () {
            if (popup.drawerShown || popup.isDrawerOpen) return;
            if (typeof popup.show === 'function') {
                popup.show();
            } else {
                dispatchDrawer('action:showDrawer', KEY);
            }
        };

        var agePopup = document.querySelector('age-verification');
        var ageVerified = document.cookie.indexOf('age-verified=true') !== -1;
        if (agePopup && !ageVerified) {
            document.addEventListener(
                'action:hideDrawer',
                function (event) {
                    if (event.detail && event.detail.drawerType === 'age-popup') {
                        window.setTimeout(show, Math.max(delay, 300));
                    }
                },
                { once: true }
            );
            return;
        }

        popup.openDrawerOnTimeout = window.setTimeout(show, delay);
    }

    function onReady() {
        openFromUrl();
        if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined(KEY).then(function () {
                scheduleAppearance(document.querySelector(POPUP_SELECTOR));
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onReady);
    } else {
        onReady();
    }
})();
